import { render, staticRenderFns } from "./SearchHistory.vue?vue&type=template&id=1aa419ca&scoped=true"
import script from "./SearchHistory.vue?vue&type=script&lang=ts"
export * from "./SearchHistory.vue?vue&type=script&lang=ts"
import style0 from "./SearchHistory.vue?vue&type=style&index=0&id=1aa419ca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa419ca",
  null
  
)

export default component.exports